import styles from './CarSelectionList.module.scss';

export default function CarSelectionList({ data, id }) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <p>No car data available.</p>;
  }

  return (
    <ul className={styles.list}>
      {data.map((item, index) => {
        // 安全地获取数�?- 根据新的Sitecore数据结构
        const itemId = item?.id || `item-${index}`;
        const itemTitle = item?.fields?.title?.value || item?.name || 'Car';
        const otrPrice = item?.fields?.['OTR price']?.value || 'from £0 OTR price';
        const financeOptionLabel = item?.fields?.['Finance Option Label']?.value || 'PCP';
        const leftBlockLabel = item?.fields?.['Left Block Label']?.value || 'APR';
        const leftBlockValue = item?.fields?.['Left Block Value']?.value || '0%';
        const rightBlockLabel = item?.fields?.['Right Block Label']?.value || 'Monthly';
        const rightBlockValue = item?.fields?.['Right Block Value']?.value || '£0';

        // 图片路径 - 从嵌套的Image字段获取
        const imageField = item?.fields?.Image?.fields?.desktopImage?.value;
        const imageUrl = imageField?.src || '';

        // 链接 - 从buttonUrl字段获取
        const buttonUrl = item?.fields?.buttonUrl?.value?.href || item?.url || '';

        return (
          <li className={styles.card} key={itemId} data-aos="fade-up">
            <div className={styles.cardImageContainer}>
              {imageUrl ? (
                <img className={styles.cardImage} src={imageUrl} alt={itemTitle} />
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '200px',
                    backgroundColor: '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#666',
                  }}
                >
                  No Image
                </div>
              )}
            </div>

            <div className={styles.cardContent}>
              <div className={styles.topRow}>
                <div className={styles.leftColumn}>
                  <div className={styles.laptopLabel}>
                    <p>{financeOptionLabel}</p>
                  </div>
                  <div className={styles.titleContainer}>
                    <h2 className={styles.title}>{itemTitle}</h2>
                    <p className={styles.otrPrice}>{otrPrice}</p>
                  </div>
                  <div className={styles.aprContainer}>
                    <p className={styles.apr}>{leftBlockLabel}</p>
                    <p className={styles.aprPrice}>{leftBlockValue}</p>
                  </div>
                </div>

                <div className={styles.rightColumn}>
                  <span className={styles.pcLabel}>{financeOptionLabel}</span>
                  <div className={styles.monthlyContainer}>
                    <p className={styles.monthly}>{rightBlockLabel}</p>
                    <p className={styles.monthlyPrice}>{rightBlockValue}</p>
                  </div>
                </div>
              </div>

              <a href={buttonUrl} className={styles.viewOffer}>
                View Offer
              </a>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
